import auth from "middlewares/auth";
import api from "api";

const headers = {
    Authorization: `Bearer ${auth.getToken()}`,
    'Content-Type': 'multipart/form-data'
}

const imageUpload = {
    uploadWithFolder: (payload) => {
        return api().post('/images', payload, {
            headers
        })
    },
    delete: (id) => {
        return api().delete(`/images/${id}`, null, { headers })
    },
    
};
 
export default imageUpload;  